import React from "react";
import { createRoot } from "react-dom/client";
import { GalleryApp } from "./GalleryApp";
import { AdminApp } from "./AdminApp";
import "./styles.css";

const isAdmin = window.location.pathname === "/admin" || window.location.pathname.startsWith("/admin/");
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>{isAdmin ? <AdminApp /> : <GalleryApp />}</React.StrictMode>,
);
